<template>
  <v-card tile>
    <loader v-if="$wait.is('getRadDetails')" class="pt-12"></loader>
    <v-card-text v-else-if="getOdabraniRad" class="pa-12 pt-0">
      <v-row no-gutters class="pb-1 pt-5">
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Naziv rada:</h3></v-col
        >
        <v-col>
          <h4 style="color: black" class="pt-2">
            {{ getOdabraniRad.naslov }}
          </h4></v-col
        >
      </v-row
      >
      <v-divider></v-divider>
      <v-row no-gutters v-if="getOdabraniRad.godina" class="pb-1 pt-1">
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Verificiran:</h3>
        </v-col>
        <div class="pa-1 pl-0" style="color: black">
          <span v-if="getOdabraniRad.verificiran == 1"> Da </span>
          <span v-else> Ne </span>
        </div>
      </v-row>
      <v-divider v-if="getOdabraniRad.godina"></v-divider>
      <v-row no-gutters v-if="getOdabraniRad.godina" class="pb-1 pt-1">
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)">Godina:</h3>
        </v-col>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.godina }}
          </span>
        </div>
      </v-row>
      <v-divider v-if="getAllAutori.length && getAllAutori"></v-divider>
      <div v-if="getAllAutori.length && getAllAutori" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Autori:</h3>
        <div
            class="pa-1 pl-0"
            v-for="(autor, i) in getAllAutori"
            :key="i"
            style="text-transform: capitalize; color: black"
        >
          <span>
            {{ autor.ime.toLowerCase() }}
            {{ autor.prezime.toLowerCase() }}
          </span>
        </div>
      </div>
      <v-divider v-if="getOdabraniRad.vrsta_rada"></v-divider>
      <div v-if="getOdabraniRad.vrsta_rada" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Vrsta rada:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.vrsta_rada.naziv }}
          </span>
        </div>
      </div>
      <v-divider v-if="getOdabraniRad.doi"></v-divider>
      <div v-if="getOdabraniRad.doi" class="pt-1 pb-2">
        <h3 style="color: rgb(8, 71, 118)">DOI:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.doi }}
          </span>
        </div>
      </div>
      <v-divider v-if="getOdabraniRad.godiste"></v-divider>
      <div v-if="getOdabraniRad.godiste" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Godište:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.godiste }}
          </span>
        </div>
      </div>
      <v-divider v-if="getOdabraniRad.mjesto_izlozbe"></v-divider>
      <div v-if="getOdabraniRad.mjesto_izlozbe" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Mjesto izložbe:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.mjesto_izlozbe }}
          </span>
        </div>
      </div>

      <v-divider v-if="getOdabraniRad.izdanje"></v-divider>
      <div v-if="getOdabraniRad.izdanje" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Izdanje rada:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.izdanje.naziv }}
          </span>
        </div>
      </div>
      <v-divider v-if="getOdabraniRad.sazetak"></v-divider>
      <div v-if="getOdabraniRad.sazetak" class="pt-1 pb-1">
        <h3 style="color: rgb(8, 71, 118)">Sažetak:</h3>
        <div class="pa-1 pl-0" style="color: black">
          <span>
            {{ getOdabraniRad.sazetak }}
          </span>
        </div>
      </div>
      <v-divider
          v-if="
          getOdabraniRad.znanstvena_podrucja.length &&
          getOdabraniRad.znanstvena_podrucja
        "
      ></v-divider>
      <div
          v-if="
          getOdabraniRad.znanstvena_podrucja.length &&
          getOdabraniRad.znanstvena_podrucja
        "
          class="pt-1 pb-1"
      >
        <h3 style="color: rgb(8, 71, 118)">Znanstvena područja:</h3>
        <div
            class="pa-1 pl-0"
            v-for="(podrucje, i) in getOdabraniRad.znanstvena_podrucja"
            :key="i"
            style="color: black"
        >
          <span class="podrucje">
            {{ podrucje.naziv.toLowerCase() }}
          </span>
        </div>
      </div>

      <v-divider
          v-if="getOdabraniRad.prijevodi.length && getOdabraniRad.prijevodi"
          class="pb-2"
      ></v-divider>
      <div
          clasS="pb-1 pt-1"
          v-if="getOdabraniRad.prijevodi && getOdabraniRad.prijevodi.length"
      >
        <div v-for="(prevod, i) in getOdabraniRad.prijevodi" :key="i">
          <h3 style="color: rgb(8, 71, 118)" v-if="prevod.jezik_id">
            {{ getJezici.find((jezik) => jezik.id == prevod.jezik_id).naziv }}
          </h3>
          <h4 style="color: rgb(8, 71, 118)" class="pt-2">Naslov:</h4>
          <div class="pt-1" style="color: black">
            {{ prevod.naslov }}
          </div>
          <h4 style="color: rgb(8, 71, 118)" class="pt-2">Sažetak:</h4>
          <div class="pt-1" style="color: black">
            {{ prevod.sazetak }}
          </div>
          <v-divider
              class="mb-2 mt-2"
              v-if="
              i < getOdabraniRad.prijevodi.length - 1 &&
              getOdabraniRad.prijevodi
            "
          ></v-divider>
        </div>
      </div>
      <v-divider
          v-if="
          getOdabraniRad.kljucne_rijeci.length && getOdabraniRad.kljucne_rijeci
        "
      ></v-divider>
      <v-row
          v-if="
          getOdabraniRad.kljucne_rijeci.length && getOdabraniRad.kljucne_rijeci
        "
          no-gutters
          class="pt-1 pb-1"
      >
        <v-col cols="12" class="pt-1 pb-1">
          <h3 style="color: rgb(8, 71, 118)">Ključne riječi:</h3>
        </v-col>
        <v-col cols="12">
          <v-chip
              outlined
              class="ma-1"
              color="primary"
              v-for="(rijec, i) in getOdabraniRad.kljucne_rijeci"
              :key="i"
          >
            {{ rijec.naziv }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row
          v-if="getOdabraniRad.linkovi.length && getOdabraniRad.linkovi"
          no-gutters
          class="pb-2"
      >
        <v-col cols="12">
          <h3 style="color: rgb(8, 71, 118)" class="pt-2">Linkovi:</h3>
        </v-col>
        <v-col cols="12">
          <v-chip
              outlined
              class="ma-1"
              color="primary"
              v-for="(link, i) in getOdabraniRad.linkovi"
              :key="i"
              @click="goToLink(link.link)"
              target="_blank"
          >
            <template v-if="link.opis_linka">
            <span v-if="link.opis_linka.length <= 30">{{
                link.opis_linka
              }}</span>
              <span v-else>{{ link.opis_linka.slice(0, 30) }}...</span>
            </template>
            <v-icon size="15" class="pl-2">mdi-open-in-new</v-icon>
          </v-chip>
        </v-col>
      </v-row>
      <v-divider
          v-if="
          getOdabraniRad.dokumenti_rada.length && getOdabraniRad.dokumenti_rada
        "
      ></v-divider>
      <v-row
          v-if="
          getOdabraniRad.dokumenti_rada.length && getOdabraniRad.dokumenti_rada
        "
          no-gutters
          class="pt-1 pb-1"
      >
        <v-col cols="12" class="pt-1 pb-1">
          <h3 style="color: rgb(8, 71, 118)">Dokumenti rada:</h3>
        </v-col>
        <v-col>
          <v-chip
              outlined
              class="ma-1"
              color="primary"
              @click="readFile(file.file_id)"
              v-for="(file, i) in getOdabraniRad.dokumenti_rada"
              :key="i"
          >
            <v-icon color="red">mdi-file-pdf</v-icon>
            Pogledajte rad
            <v-icon>mdi-arrow-right</v-icon>
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  // metaInfo: {
  //   title: "Detalji o radu  - Registar radova",
  // },
  computed: {
    ...mapGetters(["getOdabraniRad", "getJezici"]),
    getAllAutori() {
      let autori = [];
      if (
          this.getOdabraniRad.uposlenici_autori &&
          this.getOdabraniRad.uposlenici_autori.length
      ) {
        this.getOdabraniRad.uposlenici_autori.forEach((autor) => {
          if (!autori.includes(autor)) {
            autori.push(autor);
          }
        });
      }
      if (
          this.getOdabraniRad.strani_autori &&
          this.getOdabraniRad.strani_autori.length
      ) {
        this.getOdabraniRad.strani_autori.forEach((autor) => {
          if (!autori.includes(autor)) {
            autori.push(autor);
          }
        });
      }
      if (
          this.getOdabraniRad.studenti_autori &&
          this.getOdabraniRad.studenti_autori.length
      ) {
        this.getOdabraniRad.studenti_autori.forEach((autor) => {
          if (!autori.includes(autor)) {
            autori.push(autor);
          }
        });
      }

      // if(this.getOdabraniRad.uposlenici_autori && this.getOdabraniRad.uposlenici_autori.length===0 &&  !this.getOdabraniRad.strani_autori && this.getOdabraniRad.strani_autori.length===0 && 
      //  !this.getOdabraniRad.studenti_autori && this.getOdabraniRad.studenti_autori.length===0){
      //     this.getOdabraniRad.autori.forEach((autor) => {
      //     if (!autori.includes(autor)) {
      //       autori.push(autor);
      //       console.log(autor)
      //     }
      //   });

      //  }
      let numberSort = function (a, b) {
        return a.pivot.poredak - b.pivot.poredak;
      };
      return [...autori].sort(numberSort);
    },
  },
  methods: {
    readFile(id) {
      let str = this.getOdabraniRad.naslov.replace(/\s/g, "");
      str = str
          .replace(" ", "%20")
          .replace("/", "%252F")
          .replace(",", "%252C")
          .replace("?", "%253F")
          .replace("#", "%2523")
          .replace("\\", "%255C");
      let routeData = this.$router.resolve({
        path: `/${str}/pdf`,
        name: "Rad",
        query: {fileId: id},
      });
      window.open(routeData.location.path + routeData.href, "_blank");
      // this.$router.push(`/${str}/pdf?fileId=${id}`)
    },
    goToLink(link) {
      if (link.substr(0, 4) != "http") {
        window.open("//" + link, "_blank");
        // window.location.href = "//" + link;
      } else {
        window.open(link, "_blank");
        //window.location.href = link;
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch("getScientificFields");
  },
};
</script>